import { render } from "./dynamic-details.vue?vue&type=template&id=8b0a571c&scoped=true"
import script from "./dynamic-details.vue?vue&type=script&lang=js"
export * from "./dynamic-details.vue?vue&type=script&lang=js"

import "./dynamic-details.vue?vue&type=style&index=0&id=8b0a571c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0a571c"]])

export default __exports__